
import * as THREE from 'three';
import { ThreeView } from './View3dWebCad';
import { OBB } from 'three/examples/jsm/math/OBB';
import { OctreeManager } from './Octree/OctreeManager';
import { MM_PER_M } from '../../webcad/Constants';

export class ItemScale {

    private vec3: THREE.Vector3;
    private obb: OBB;
    
    constructor(private object: THREE.Object3D) {
        this.vec3 = new THREE.Vector3();
        this.obb = this.object.userData.obb.obb;
    }

    public setScale(width: number, depth: number, height: number) {
        this.applyScale(width, depth, height);
        this.refreshOctree();

        ThreeView.get().updateScale(this.object);
    }

    /**
     * サイズと設置高さ（床面からの原点の高さ）を反映し、2Dへ1回で通知する
     * @param worldHeightMm 原点のワールド高さ(mm) = FL + 設置高さ
     */
    public setScaleAndHeight(width: number, depth: number, height: number, worldHeightMm: number): void {
        this.applyScale(width, depth, height);

        const worldPosition = this.object.getWorldPosition(new THREE.Vector3());
        worldPosition.y = worldHeightMm / MM_PER_M;
        this.object.position.copy(this.object.parent ? this.object.parent.worldToLocal(worldPosition) : worldPosition);
        this.refreshOctree();

        ThreeView.get().updateScaleAndPosition(this.object);
    }

    private applyScale(width: number, depth: number, height: number): void {
        const size = this.obb.getSize(this.vec3);
        const ScaleX = width / Math.abs(size.x * MM_PER_M); // mm to m
        const ScaleY = height / Math.abs(size.y * MM_PER_M);
        const ScaleZ = depth / Math.abs(size.z * MM_PER_M);

        this.object.scale.set(ScaleX, ScaleY, ScaleZ);
    }

    private refreshOctree(): void {
        ThreeView.get().OctreeManager = new OctreeManager(ThreeView.get().wcItemmgr.houseData);
        // 画角内判定
        ThreeView.get().CameraTarget.getTargets(ThreeView.get().wcCameras.camera.me, ThreeView.get().OctreeManager.nodeStatus);
    }

}